import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=521055f9&scoped=true"
import script from "./inventory.vue?vue&type=script&lang=ts"
export * from "./inventory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521055f9",
  null
  
)

export default component.exports